import React from 'react';
import type { FontSize, FontWeight } from './Text';

const getFontSize = (size: FontSize): string => {
    switch (size) {
        case 'xsmall':
            return '12px';
        case 'small':
            return '14px';
        case 'medium':
            return '16px';
        case 'large':
            return '18px';
        case 'xlarge':
            return '20px';
        case 'xxlarge':
            return '24px';
        default:
            return '14px';
    }
};

const getFontWeight = (weight: FontWeight): number => {
    switch (weight) {
        case 'normal':
            return 400;
        case 'semi-bold':
            return 500;
        case 'bold':
            return 600;
        default:
            return 400;
    }
};

export interface SecondaryTextProps {
    children: React.ReactNode;
    fontWeight?: FontWeight;
    size?: FontSize;
    textTransform?: 'uppercase' | 'lowercase' | 'capitalize' | 'none';
    className?: string;
    style?: React.CSSProperties;
}

const SecondaryText: React.FC<SecondaryTextProps> = ({
    children,
    fontWeight = 'normal',
    size = 'small',
    textTransform = 'none',
    className = '',
    style = {},
}) => {
    const secondaryStyles: React.CSSProperties = {
        fontSize: getFontSize(size),
        fontWeight: getFontWeight(fontWeight),
        color: 'var(--malachite-text-dimmed)',
        textTransform,
        lineHeight: '1.4',
        ...style,
    };

    return (
        <span className={className} style={secondaryStyles}>
            {children}
        </span>
    );
};

export default SecondaryText;
